<template lang="pug">
  v-container
    v-row
      v-col
        documentation
      v-col
        apis
    v-row
      v-col
        transactions
      v-col
        roadmap
    v-row
      v-col
        support
      v-col
        monitor(height="100%")
</template>

<script>
export default {
  name: "Home",
  components: {
    DrawerMenu: () => import("../../components/tec/core/DrawerMenu"),
    PageNavBar: () => import("../../components/tec/core/PageNavBar"),
    Documentation: () => import("../../components/tec/Documentation"),
    Apis: () => import("../../components/tec/Apis"),
    Transactions: () => import("../../components/tec/Transactions"),
    Roadmap: () => import("../../components/tec/Roadmap"),
    Support: () => import("../../components/tec/Support"),
    Monitor: () => import("../../components/tec/Monitor"),
  },
  data: () => ({
    expandOnHover: false,
  }),
};
</script>